import { render, staticRenderFns } from "./Forms.vue?vue&type=template&id=41036dc2"
import script from "./Forms.vue?vue&type=script&lang=js"
export * from "./Forms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_acadmin_online_docker/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41036dc2')) {
      api.createRecord('41036dc2', component.options)
    } else {
      api.reload('41036dc2', component.options)
    }
    module.hot.accept("./Forms.vue?vue&type=template&id=41036dc2", function () {
      api.rerender('41036dc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/template/components/Forms.vue"
export default component.exports